module.exports = __webpack_public_path__ + "static/devWeek.resized-48cd71e04f2a8f2e0304e8056d51c26c.jpg";